import { useEditMode } from '@/context/EditModeContext';

// Renders admin-only guidance; never visible to the public.
export default function AdminHint({ children, className = 'text-xs text-charcoal-muted italic' }) {
  const { editMode } = useEditMode();
  if (!editMode) return null;
  return <div className={className} data-testid="admin-hint">{children}</div>;
}
